// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./TicketAdder.module.css";
// CSS
// Models
import { I_TicketSubject } from "../../../../../Models/interfaces";
// Models
// Services
import { getTicketSubjectsService } from "../../../../../Services/Tickets/get/getTicketSubjectsService";
// Services
import { createNewTicketAndSendToServerService } from "../../../../../Services/Tickets/post/createNewTicketAndSendToServerService";
// Contexts
import { UserTokenContext } from "../../../../../Contexts/userToken";
// Contexts
// Utils
import SelectOptionBuilder from "../../../../../Utils/SelectOptionBuilder/SelectOptionBuilder";
// Utils
// Modules
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
// Modules
// Icons
import { BiArrowBack } from "react-icons/bi";
import { IoIosArrowDown } from "react-icons/io";
import Spinner from "../../../../../Utils/Spinner/Spinner";
import { toast } from "react-toastify";
// Icons

const TicketAdder: React.FC<{hideBackArrow?: boolean}> = (props) => {
  // States
  const [ticketSubjects, setTicketSubjects] = useState<I_TicketSubject[]>([]);
  const [selectedTicketSubject, setSelectedTicketSubject] = useState<
    number | string
  >(0);
  const [selectedTicketSubjectTitle, setSelectedTicketSubjectTitle] =
    useState<string>("موضوع تیکت را انتخاب کنید");
  const [ticketTitle, setTicketTitle] = useState<string>("");
  const [ticketText, setTicketText] = useState<string>("");
  const [formFiles, setFormFiles] = useState<
    { name: number; value: string | any }[]
  >([]);

  const [isPending, setIsPending] = useState<boolean>(false);
  // States
  /*************************************** */
  /*************************************** */
  /*************************************** */
  const navigate = useNavigate();
  /*************************************** */
  /*************************************** */
  /*************************************** */
  // Contexts
  const userToken = useContext(UserTokenContext);
  // Contexts
  // LifeCycles
  useEffect(() => {
    getTicketSubjectsService(userToken).then(({ data }) => {
      setTicketSubjects(data);
    });
  }, [userToken]);
  // LifeCycles

  return (
    <div
      className={`${styles.ticketAdderContainer} w-full flex flex-col items-end justify-center p-4`}
    >
      <div className="flex items-center justify-between flex-row-reverse my-8 w-full">
        <h1 className="text-xl self-center ">ایجاد تیکت جدید</h1>
        {!props.hideBackArrow && (
          <BiArrowBack
            onClick={() => {
              navigate(-1);
            }}
            className="text-2xl"
          />
        )}
      </div>
      <SelectOptionBuilder
        dataForBuildOptions={ticketSubjects.map((item) => ({
          id: item.id,
          title: item.name,
        }))}
        initialShowName={selectedTicketSubjectTitle}
        onClick={(data) => {
          setSelectedTicketSubject(data);
          setSelectedTicketSubjectTitle(
            ticketSubjects.filter((item) => String(item.id) === String(data))[0]
              .name,
          );
        }}
        className="rounded-2xl w-full"
        elementForShow={
          <p className="w-full flex flex-row-reverse items-center justify-between px-2">
            <span>{selectedTicketSubjectTitle}</span>
            <IoIosArrowDown />
          </p>
        }
      />
      <input
        type="text"
        placeholder="عنوان تیکت ....."
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setTicketTitle(e.target.value);
        }}
        value={ticketTitle}
        className={`${styles.ticketTitle} mt-4 placeholder:text-right p-2 w-full rounded-lg text-sm`}
      />
      <textarea
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          setTicketText(e.target.value);
        }}
        value={ticketText}
        placeholder="پاسخ خود را وارد کنید ...."
        className="mt-8 rounded-xl p-2 text-sm"
      />
      {formFiles.map((item, index) => (
        <div
          key={item.name}
          className="flex flex-row items-center justify-between mt-4 w-full"
        >
          <input
            type="file"
            accept="image/png, image/gif, image/jpeg, application/pdf"
            name={Math.random() * 120000 + ""}
            multiple={false}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const copyOfFormFiles = [...formFiles];
              const selectedItemIndex = formFiles.findIndex(
                (_item) => _item.name === item.name,
              );
              console.log(selectedItemIndex);
              if (!e.target.files) return;
              copyOfFormFiles[selectedItemIndex].value = e.target.files[0];
              setFormFiles(copyOfFormFiles);
            }}
            className="text-sm"
          />
          <span
            onClick={() => {
              const copyOfFormFiles = [...formFiles];
              const selectedItemIndex = formFiles.findIndex(
                (item) => item.name === index,
              );
              copyOfFormFiles.splice(selectedItemIndex, 1);
              setFormFiles(copyOfFormFiles);
            }}
            style={{
              cursor: "pointer",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
              display: "block",
              background: "#dc3545",
              borderRadius: "4px",
              color: "#fff",
              marginTop: "4px",
              marginBottom: "4px",
            }}
            className="text-xs"
          >
            حذف فایل
          </span>
        </div>
      ))}
      <button
        type="submit"
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
        className={`${styles.submitBtn} px-4 py-1 rounded-lg text-white text-sm`}
        onClick={() => {
          setFormFiles((prevState) => [
            ...prevState,
            {
              name: Math.random() * 120000,
              value: "",
            },
          ]);

          return;
        }}
      >
        افزودن فایل
      </button>
      <button
        className={`${styles.submitBtn} w-full py-2 mt-6 text-white rounded-xl flex items-center justify-center text-sm`}
        onClick={() => {
          if (isPending) return;
          if (selectedTicketSubject === 0) {
            toast("موضوع تیکت را انتخاب کنید");
            return;
          }
          if (ticketTitle.length < 4) {
            toast("عنوان تیکت را کامل بنویسید");
            return;
          }
          if (ticketText.length < 5) {
            toast("متن را به طور کامل بنویسید");
            return;
          }
          setIsPending(true);
          createNewTicketAndSendToServerService(
            userToken,
            formFiles.filter((item) => item.value !== ""),
            ticketText,
            ticketTitle,
            selectedTicketSubject,
          )
            .then(
              ({
                data: {
                  responseCode,
                  success,
                  ticket: { id },
                },
              }) => {
                if (Number(responseCode) !== 200) return;
                Swal.fire({ icon: "success", title: success }).then(() => {
                  setIsPending(false);
                  navigate(`/ticketing/tickets/${id}`);
                });
              },
            )
            .catch((err) => {
              setIsPending(false);
              console.log(err);
              Swal.fire({
                icon: "error",
                title: err?.response?.data?.message
                  ? err?.response?.data?.message
                  : err.message,
              });
            });
        }}
      >
        {isPending ? (
          <>
            <Spinner />
          </>
        ) : (
          <>ثبت</>
        )}
      </button>
    </div>
  );
};

export default TicketAdder;
